<template>
    <div class="item-card" :class="{sub, notice, pickedNotice: picked_notice && (subject._id == picked_notice._id)}" @click="toNotice(notice)">
        <div class="card-header overflow-hidden">
            <div class="name mt-4">{{subject.name}}</div>
            <DropdownMenu v-if="!sub" :button-classes="'right'" :actions="actions || subjectActions"/>
        </div>
        <div class="card-content">
            <div class="card-body px-6" v-html="subject.body"/>
        </div>
        <div class="card-footer px-6 pb-6 mt-2">
            <div class="navigation" v-if="sub" @click="toSub(sub)">{{sub.parent_name}}</div>
            <div class="time">{{moment(+new Date(subject && subject.createdAt)).calendar()}}</div>
        </div>
    </div>
</template>

<script lang='ts'>
        import {mapActions, mapGetters, mapMutations} from 'vuex'
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
    import DropdownMenu from '../misc/DropdownMenu.vue'
    import moment from 'moment'
    import Images from '@/components/popups/Images.vue'

    moment.locale('ru')

    export default Vue.extend({
        props: {
            notice: Object,
            sub: Object,
            actions: Array,
        },
        components: {
            Images,
            DropdownMenu,
        
        },
        data() {
            return {
                subject: this.notice || this.sub,
                moment
            }
        },
        computed: {
            ...mapGetters(['current_feed', 'current', 'current_task', 'themes', 'feeds', 'picked_notice']),
            subjectActions() {
                if (this.notice) {
                    if (!this.completedInFeedAndTask) {
                        return [
                            {
                                label: 'В архив',
                                handler: this.toggleComplete
                            }
                        ]
                    } else {
                        return [
                            {
                                label: 'Восстановить',
                                handler: this.toggleComplete
                            },
                            {
                                label: 'Удалить',
                                handler: this.del
                            },
                        ]
                    }
                }
                if (this.sub) {
                    return [
                            {
                                label: 'В архив',
                                handler: this.toggleComplete
                            },
                            {
                                label: 'Удалить',
                                handler: this.del
                            },
                    ]
                }
                return []
            },
            images() {
                const regexp = /(\(.*?)?\b((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig
                const links = this.subject.body.match(regexp)
                const subjectImages = ((this.subject && this.subject.images) || [])
                if (links) {
                    const regexpLinks = new RegExp('http(?::\\/\\/|s:\\/\\/).*?\\.(?:gif|jpg|jpeg|png)', 'i')
                    const filteredLinks = [...links.map(el => el.split('"').join(''))].filter(el =>  el.match(regexpLinks))
                    return [...subjectImages, ...filteredLinks.map(el => el.replace(new RegExp("amp;", 'g'), "")) ]
                } else return [...subjectImages]
            },
            isNoticeRelevant() {
                return true ? this.$route.name == "themes" : this.$route.name == "feeds"
            },
            completedInFeedAndTask() {
                return !this.isNoticeRelevant ? this.notice.completedInFeed : this.current && this.current_task && this.notice && ~this.notice.completedInTasks.indexOf(this.current_task._id) 
            },
        },
        methods: {
        ...mapMutations(['SET_CURRENT_FEED']),
            ...mapActions(['editNotice', 'editSub', 'setCompletedNotice', 'toggleCompletedRelevantNotice', 'delNotice', 'delSub', 'setCompletedSub']),
            async toggleComplete (){
                //1674
                //1533 - wo v-btn
                //800 - textrea 680 - just div
                //400 - pushes
                if (this.notice) {
                    if (!this.isNoticeRelevant) {
                        await this.setCompletedNotice({feed_id: this.current_feed._id, notice_id: this.notice._id, value: !this.notice.completedInFeed})
                    } else {
                        await this.toggleCompletedRelevantNotice({current_task_id: this.current_task._id, notice: this.notice})
                    }
                } else {
                    this.setCompletedSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, value: !this.sub.completed})
                }
            },
            async del() {
                if (this.notice) {
                    await this.delNotice({feed_id: this.current_feed._id, notice_id: this.notice._id})
                    this.rename_flag = false
                } else {
                    await this.delSub({theme_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id})   
                }
            },
            toNotice(notice) {
                if (notice) {  
                    this.$emit('activated')                  
                    const feed = this.feeds.find(feed => {
                        return feed.notices.find(el => el._id == this.notice._id)
                    })
                    this.SET_CURRENT_FEED(feed)
                    this.feedBody = feed.body  
                    this.$emit('toCloseWindow')
                    this.$root.$emit('selectElementMenu')
                    this.$router.push({path:`/feeds/${feed.route_name}#notice-id-${this.notice._id}`})
                    this.$root.$emit('toCurrentNotice', notice)
                    let oldScroll = window.scrollY
                    const toHash = setInterval(() => {
                        const elementNotice = document.getElementById(`notice-id-${this.notice._id}`)
                        if (elementNotice) { 
                            this.$vuetify.goTo(`#notice-id-${this.notice._id}`)
                        }
                        if (oldScroll != window.scrollY || oldScroll == 0) {
                            clearInterval(toHash)
                        } 
                        oldScroll = window.scrollY
                    },30)
                }
            },
            toSub(sub) {
                if (sub) {    
                    this.$emit('activated')                
                    const theme = this.themes.find(theme => {
                        return theme.tasks.find(task => {
                            return task.subs.find(item => item._id == sub._id)
                        })
                    })
                    const task = theme.tasks.find(task => {
                        return task.subs.find(item => item._id == sub._id)
                    })
                    this.$router.push(`/theme/${theme.route_name}/${task.route_name}`) 
                    this.$root.$emit('toCurrentSub', sub)
                }
            },
        },
    })

    </script>

<style lang="scss">
    .item-card{

    }
</style>

<style lang="scss" scoped>
    .name{
        color: black;
        font-size: 18px;
    }
    .card-header{
        display: flex;
        justify-content: space-between;
        padding-left: 24px;
        padding-top: 2px;
        align-items: center;
        font-weight: 500;
    }
    .card-header{
        min-height: 36px;
    }
    .navigation{
        color: #BEBEBE;
        font-size: small;
        text-decoration: underline;
        cursor: pointer;
    }
    .card-body{
        color: #333;
        font-size: small;
    }
   .item-card.mobile{
        min-width: 100%;  
    }
    .item-card{
        height: 240px;
        border: 1px solid #F2F2F2;
        box-sizing: border-box;
        border-radius: 7px;
        background: white;
        display: flex;
        flex-direction: column;
        &.sub {
            height: 320px;
        }
        .card-content{
            overflow-y: auto;
            flex-grow: 1;
        }
        .path {
            font-size: .800rem;
            text-decoration: underline;
            color: #1976d2;
            cursor: pointer;
        }       
        &.pickedNotice {
            border: 1px solid black;
        }
    }
    .time{
        font-family: Roboto;
        font-style: italic;
        font-weight: normal;
        font-size: small;
        line-height: 23px;
        color: #BEBEBE;
    }
    .close_button{
        float: right;
        opacity: .3;
        &:hover{
            opacity: 1;
        }
    }
    .v-time-picker-clock__hand{
        background: #b9f3a6 !important;
    }
</style>
